import React from "react";

import { i18n } from "../../../translate/i18n";

const PERIOD_OPTIONS = [
	{ value: "0", labelKey: "transactions.filters.periodAll" },
	{ value: "1", labelKey: "transactions.filters.periodToday" },
	{ value: "2", labelKey: "transactions.filters.periodYesterday" },
	{ value: "3", labelKey: "transactions.filters.period7d" },
	{ value: "4", labelKey: "transactions.filters.period30d" },
	{ value: "5", labelKey: "transactions.filters.periodMonth" },
];

const STATUS_OPTIONS = [
	{ value: "all", labelKey: "transactions.filters.statusAll" },
	{ value: "PENDING", labelKey: "transactions.status.pending" },
	{ value: "RECEIVED", labelKey: "transactions.status.received" },
];

function FilterPill({ active, onClick, children }) {
	return (
		<button
			type="button"
			className={`rounded-full px-3 py-1 text-xs font-semibold transition-colors ${
				active
					? "bg-primary/15 text-primary"
					: "border border-default-200 text-default-600 hover:bg-default-100 dark:border-default-700 dark:text-default-400"
			}`}
			onClick={onClick}
		>
			{children}
		</button>
	);
}

export default function TransactionFilters({
	status,
	period,
	searchParam,
	onStatusChange,
	onPeriodChange,
	onSearchChange,
}) {
	return (
		<div className="card">
			<div className="card-body space-y-4">
				<div className="flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
					<div className="min-w-0 flex-1">
						<label className="mb-2 block text-sm font-medium text-default-700 dark:text-default-200">
							{i18n.t("transactions.filters.search")}
						</label>
						<input
							type="search"
							className="form-input w-full"
							placeholder={i18n.t("transactions.filters.searchPlaceholder")}
							value={searchParam}
							onChange={(e) => onSearchChange(e.target.value)}
						/>
					</div>
					<div className="w-full lg:w-56">
						<label className="mb-2 block text-sm font-medium text-default-700 dark:text-default-200">
							{i18n.t("transactions.filters.period")}
						</label>
						<select
							className="form-select w-full"
							value={period}
							onChange={(e) => onPeriodChange(e.target.value)}
						>
							{PERIOD_OPTIONS.map((opt) => (
								<option key={opt.value} value={opt.value}>
									{i18n.t(opt.labelKey)}
								</option>
							))}
						</select>
					</div>
				</div>

				<div className="flex flex-wrap items-center gap-2">
					<span className="text-xs font-semibold uppercase tracking-wide text-default-500">
						{i18n.t("transactions.filters.status")}:
					</span>
					{STATUS_OPTIONS.map((opt) => (
						<FilterPill
							key={opt.value}
							active={status === opt.value}
							onClick={() => onStatusChange(opt.value)}
						>
							{i18n.t(opt.labelKey)}
						</FilterPill>
					))}
				</div>
			</div>
		</div>
	);
}
